import axios from 'axios';

// REACT_APP_API_URL is expected to be the API root WITH a trailing slash,
// e.g. https://api.premikalove.com/ . The previous `${env}api/v1' || fallback`
// was dead — a template literal is always truthy, so an unset env silently
// produced "undefinedapi/v1". Guard explicitly and normalise the slash.
const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:3000/';
if (!process.env.REACT_APP_API_URL) {
  // eslint-disable-next-line no-console
  console.warn(
    'REACT_APP_API_URL is not set — falling back to http://localhost:3000/. ' +
      'Set it (with a trailing slash) before building for production.',
  );
}
const baseURL = `${API_ROOT.replace(/\/?$/, '/')}api/v1`;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'platform': 'admin'
  },
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('data'))?.auth_token || '';
    if (token) {
      config.headers['Authorization'] = token;
      config.platform = 'admin'
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const  d = error?.response?.data;
    if (error.response && error.response.status === 401 ||  d?.code === "UNAUTHORIZED" ||
        d?.message === "Unauthorized"
       ) {
       localStorage.clear();
       sessionStorage.clear();
       window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
